var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container", attrs: { id: "goods-edit" } }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("运费模板")]),
            ]),
            _c("el-breadcrumb-item", [
              this.$route.query.type == "add"
                ? _c("div", { staticClass: "div2" }, [_vm._v(" 新增模板 ")])
                : _c("div", { staticClass: "div2" }, [_vm._v("编辑模板")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h2", [_vm._v("运费模板")]),
        _c(
          "el-form",
          {
            ref: "infoForm",
            staticClass: "info-form",
            attrs: {
              model: _vm.infoForm,
              rules: _vm.infoRules,
              "label-width": "120px",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "模板名称" } },
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: {
                    placeholder: "请输入模板名称",
                    maxlength: "20",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.form.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "是否包邮" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.form.isFree,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isFree", $$v)
                      },
                      expression: "form.isFree",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 0 } }, [
                      _vm._v("自定义邮费"),
                    ]),
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("包邮")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "是否同步平台" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.form.isSync,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isSync", $$v)
                      },
                      expression: "form.isSync",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.form.isFree == 0
              ? _c(
                  "el-form-item",
                  { attrs: { label: "运送方式" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { onclick: "return false;" },
                        model: {
                          value: _vm.form.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "type", $$v)
                          },
                          expression: "form.type",
                        },
                      },
                      [
                        _vm._v(
                          " 快递（除指定地区外，其余地区的运费采用“默认运费”）"
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.form.isFree == 0
              ? _c(
                  "el-form-item",
                  { attrs: { label: "邮费设置" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.selectType },
                        model: {
                          value: _vm.form.calculType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "calculType", $$v)
                          },
                          expression: "form.calculType",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("按件数"),
                        ]),
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("按重量"),
                        ]),
                      ],
                      1
                    ),
                    _vm.form.calculType == 1 && this.$route.query.type == "edit"
                      ? _c("number", {
                          key: Math.random(),
                          attrs: {
                            tableData: _vm.tableData,
                            freight: _vm.freight1,
                            baseNumber: _vm.baseNumber1,
                            addNum: _vm.addNum1,
                            addPrice: _vm.addPrice1,
                          },
                          on: { change: _vm.handleChange },
                        })
                      : _vm._e(),
                    _vm.form.calculType == 1 && this.$route.query.type == "add"
                      ? _c("number", {
                          attrs: {
                            tableData: _vm.tableData,
                            freight: _vm.freight1,
                            baseNumber: _vm.baseNumber1,
                            addNum: _vm.addNum1,
                            addPrice: _vm.addPrice1,
                          },
                          on: { change: _vm.handleChange },
                        })
                      : _vm._e(),
                    _vm.form.calculType == 2 && this.$route.query.type == "edit"
                      ? _c("weight", {
                          key: Math.random(),
                          attrs: {
                            tableData: _vm.tableData2,
                            freight: _vm.freight2,
                            baseNumber: _vm.baseNumber2,
                            addNum: _vm.addNum2,
                            addPrice: _vm.addPrice2,
                          },
                          on: { change: _vm.handleChange },
                        })
                      : _vm._e(),
                    _vm.form.calculType == 2 && this.$route.query.type == "add"
                      ? _c("weight", {
                          attrs: {
                            tableData: _vm.tableData2,
                            freight: _vm.freight2,
                            baseNumber: _vm.baseNumber2,
                            addNum: _vm.addNum2,
                            addPrice: _vm.addPrice2,
                          },
                          on: { change: _vm.handleChange },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.form.isFree == 0
              ? _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: true },
                        model: {
                          value: _vm.form.hasFree,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "hasFree", $$v)
                          },
                          expression: "form.hasFree",
                        },
                      },
                      [_vm._v("指定条件包邮（可选）")]
                    ),
                    _c("free-delivery", {
                      attrs: { tableData: _vm.tableDataF },
                      on: { change: _vm.handleChangeZ },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              width: "30%",
              "text-align": "center",
              "padding-bottom": "20px",
            },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [_vm._v("确认")]
            ),
            _c("el-button", { on: { click: _vm.back } }, [_vm._v("返回")]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }